import { createErrorBoundaryForDomain } from 'lib/error/utils/createErrorBoundaryForDomain';

export const ErrorBoundaryForApp = createErrorBoundaryForDomain('App');
